import { render, staticRenderFns } from "./SoftwareHome.vue?vue&type=template&id=cb5ed108&scoped=true"
import script from "./SoftwareHome.vue?vue&type=script&lang=js"
export * from "./SoftwareHome.vue?vue&type=script&lang=js"
import style0 from "./SoftwareHome.vue?vue&type=style&index=0&id=cb5ed108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5ed108",
  null
  
)

export default component.exports